export default class TableFilter {
  constructor(holder, options) {
    this.holder = holder;
    this.options = Object.assign({
      activeClass: 'active',
      table: 'table',
      filtersWrap: '.checkboxes-wrap',
      typesFilter: 'input[type="checkbox"]',
      roomsFilter: 'input[type="checkbox"]',
      disabledFilter: 'input[type="checkbox"]',
      priceMinFilter: '#min-price',
      priceMaxFilter: '#max-price'
    }, options);
    this.init();
  }
  init() {
    this.findElements();
    this.attachEvents();
  }
  findElements() {
    this.filtersWrap = this.holder.querySelector(this.options.filtersWrap);
    this.typesFilter = this.filtersWrap.querySelectorAll(this.options.typesFilter);
    this.roomsFilter = this.filtersWrap.querySelectorAll(this.options.roomsFilter);
    this.priceMinFilter = this.filtersWrap.querySelector(this.options.priceMinFilter);
    this.priceMaxFilter = this.filtersWrap.querySelector(this.options.priceMaxFilter);
    this.disabledFilter = this.filtersWrap.querySelector(this.options.disabledFilter);
    this.table = this.holder.querySelector(this.options.table);
    this.filterItems = this.table.querySelectorAll('tbody tr');
  }
  attachEvents() {
    this.typesFilter.forEach((it) => it.addEventListener('change', this.filterTable.bind(this)));
    this.roomsFilter.forEach((it) => it.addEventListener('change', this.filterTable.bind(this)));
    this.priceMinFilter.addEventListener('change', this.filterTable.bind(this));
    this.priceMaxFilter.addEventListener('change', this.filterTable.bind(this));
    this.disabledFilter.addEventListener('change', this.filterTable.bind(this));
  }
  filterTable() {
    const typesFilter = [...this.typesFilter].filter((it) => it.checked);
    const roomsFilter = [...this.roomsFilter].filter((it) => it.checked);
    const minPrice = this.priceMinFilter.value;
    const maxPrice = this.priceMaxFilter.value;
    const disabledFilterFlag = this.disabledFilter.checked;
    
    if (!disabledFilterFlag && !typesFilter.length && !roomsFilter.length && !minPrice && !maxPrice) {
      this.filteredItems = this.filterItems;
      this.appendFilteredItems();
      return;
    };

    this.filteredItems =  this.filterItems || [];

    this.filterAvailable(disabledFilterFlag);
    this.filterRooms(roomsFilter);
    this.filterPrice(minPrice, maxPrice);
    this.filterTypes(typesFilter);
    this.appendFilteredItems();
  }
  clearFilters(parent) {
    if (!parent) return;
    while(parent.firstChild)
    parent.removeChild(parent.firstChild);
  }
  filterPrice(min, max) {
    if (isNaN(min) || isNaN(max)) return;
    
     this.filteredItems = [...this.filteredItems].filter(item => {
        const price = +item.getAttribute('data-price');

        return price >= +min && price <= +max;
     });
  }
  filterTypes(filters) {
    if (!filters.length) return;

    this.filteredItems =  [...this.filteredItems].filter((it) => 
       filters.some((filter) => it.getAttribute('data-type').toLowerCase() === filter.value.toLowerCase())
    );
  }
  filterRooms(filters) {
    if (!filters.length) return;
  
    this.filteredItems =  [...this.filteredItems].filter((it) => {
     return  filters.some((filter) => {
         return it.getAttribute('data-rooms').toLowerCase() === filter.value.toLowerCase();
      });
    });
  }
  filterAvailable(filter) {
    if (!filter) return;
    this.filteredItems =  [...this.filteredItems].filter((it) => it.getAttribute('data-status') !== 'disable');
  }
  appendFilteredItems() {
    const parent = this.table.querySelector('tbody');
    this.clearFilters(parent);
    this.filteredItems.forEach((it) => parent.appendChild(it));
    if (typeof this.options.filtered === 'function') this.options.filtered();
  }
}